import React from "react";
import Home from "@/components/Home/index";

export default function IndexPage() {
  return <Home />;
}
